import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import contactInfo from 'src/shared/components/HelpBar/contact';
import { type HelpBarData, type ContactData } from 'src/shared/components/HelpBar/types';

export const contactData = (locale: string): ContactData[] => {
  if (!locale) {
    return [];
  }

  const localeContactInfo = contactInfo(locale);

  return [
    {
      value: localeContactInfo?.SUPPORT_EMAIL_ADDRESS,
      link: `mailto:${localeContactInfo?.SUPPORT_EMAIL_ADDRESS}`,
      Icon: MailOutlineRoundedIcon,
      label: 'email'
    }
  ];
};

export const helpBarData = (locale: string): HelpBarData[] => {
  if (!locale) {
    return [];
  }

  const localeContactInfo = contactInfo(locale);

  return [
    /**
     * Commented until we have the videos available
    {
        title: 'videotutorial',
        onclick: () => {openVideoModal()},
        icon: '/images/icons/play-icon.svg'
    },
     */
    {
      title: localeContactInfo?.SUPPORT_EMAIL_ADDRESS,
      link: `mailto:${localeContactInfo?.SUPPORT_EMAIL_ADDRESS}`,
      Icon: MailOutlineRoundedIcon
    }
  ];
};
